<template>
  <div>
    <v-card class="no-shadow">
      <v-toolbar color="primary" dark class="mb-4 v-toolbar-header">
        <v-toolbar-title aling="center"><v-icon>mdi-file-document-multiple-outline</v-icon>Crear Formulario</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          elevation="2"
          @click="goVolver"
          class="btn-principal"
        >
        <v-icon>mdi-chevron-left</v-icon>
        Volver
        </v-btn>
      </v-toolbar>
      
        <v-card>
          <v-card-text>
            <v-container>
            <!-- nombreFormulario -->
             <v-row>

                <v-col cols="12" >
                  <v-text-field
                    v-model="nombreFormulario"
                    label="Nombre del formulario"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" class="text-right">
                  <v-btn dark color="blue" @click="crearPregunta = true">
                    <v-icon>plus-thick</v-icon>
                    Guardar Formulario</v-btn
                  >
                </v-col>
                
              </v-row>
              <!-- end nombreFormulario -->
              <!-- crearPregunta -->
              <v-row>
                <v-col cols="12" class="text-right" v-if="crearPregunta">
                  <v-btn dark color="blue" @click="cargarPreguntas = true">
                    <v-icon>plus-thick</v-icon>
                    Nueva Pregunta</v-btn
                  >
                </v-col>
                
              </v-row>
              <!-- crearPregunta -->
            </v-container>
          </v-card-text>
        </v-card>

        <v-card class="mt-3"  v-if="preguntas.length > 0">
          <v-card-text>
            <v-row>
              <v-col cols="12" v-for="(item, index) in preguntas" :key="index">
                <v-row>
                  <v-col cols="12" class="text-pregunta"> {{ item.text }} </v-col>

                <v-col cols="12" v-if="item.tipo == 3">
                  <v-text-field
                    v-model="formRespuesta.text"
                    label="Ingresa tu respuesta"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" v-if="item.tipo == 5">
               
                  <div class="text-center">
                  <vueSignature class="marginFirma" ref="signature" :sigOption="option" :w="'auto'" :h="'400px'"  > </vueSignature> 
                </div>
                <div cols="12 mt-2" class="text-right">
                 <v-btn class="mt-3" dark color="gray" @click="save">
                    <v-icon>plus-thick</v-icon>
                    Guardar </v-btn>
                </div>
              
                </v-col>

                <v-col cols="12" v-if="item.tipo == 4">
                <input type="file" @change="previewFiles" multiple>

                </v-col>

                <v-col cols="12" class="respuestas" v-if="respuestas.length > 0">
                  <v-row>
                    <v-col cols="12" class="mt-0 pt-0 mb-0 pb-0"
                    v-for="(item2, j) in preguntas[index].respuestas"
                    :key="j"
                  >
                    <v-row>
                      <v-col cols="12" class="mt-0 pt-0 mb-0 pb-0">
                      <v-row>
                        <v-col cols="12" class="mt-0 pt-0 mb-0 pb-0" v-if="item.tipo == 0">
                          <v-checkbox :label="`${item2.text}`" class="mt-0"></v-checkbox>
                        </v-col>
                        <v-col cols="12" v-if="item.tipo == 1" class="mt-0 pt-0 mb-0 pb-0">
                          <v-radio-group>
                            <v-radio
                              :key="index"
                              :label="`${item2.text}`"
                              :value="index"
                            ></v-radio>
                          </v-radio-group>
                        </v-col>
                        <v-col cols="12" class="mt-0 pt-0 mb-0 pb-0" v-if="item.tipo == 2">
                          <v-radio-group>
                            <v-radio
                              :key="index"
                              :label="`${item2.text}`"
                              :value="index"
                            ></v-radio>
                          </v-radio-group>
                        </v-col>

                       
                      </v-row>
                    </v-col>
                    </v-row>

                  </v-col>
                  </v-row>
                </v-col>

                     <v-col
                          cols="12"
                          class="text-right"
                          v-if="item.tipo != 3 && item.tipo != 5 "
                        >
                          <v-btn dark color="blue" @click="indexPregunta()">
                            <v-icon>plus-thick</v-icon>
                            Nueva Respuesta</v-btn
                          >
                        </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>

        </v-card>
      
    </v-card>
    <v-dialog v-model="cargarPreguntas" persistent width="900px">
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="12" class="text-center">
          <label>Datos de la pregunta </label>
        </v-col>
        <v-col cols="12" class="margin">
          <v-text-field
            v-model="formPreguntas.text"
            label="Texto"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" class="margin">
          <v-select
            :items="tipoPregunta"
            v-model="formPreguntas.tipo"
            label="Seleccione el tipo de pregunta"
            outlined
          ></v-select>
        </v-col>
        <v-row class="ml-0">
          <v-col cols="6" class="text-left">
            <v-btn
              dark
              color="blue"
              @click="cargarPreguntas = false"
              class="margin"
            >
              <v-icon>plus-thick</v-icon>
              volver</v-btn
            >
          </v-col>
          <v-col cols="6" class="text-right">
            <v-btn dark color="blue" @click="savePregunta" class="margin mr-0">
              <v-icon>plus-thick</v-icon>
              Guardar</v-btn
            >
          </v-col>
        </v-row>
      </v-row>
    </v-dialog>
    <v-dialog v-model="cargarRespuesta" width="900px">
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="12" class="text-center">
          <label>Datos de la respuesta </label>
        </v-col>

        <v-col cols="12" class="margin">
          <v-text-field
            v-model="formRespuesta.text"
            label="Pregunta"
            required
          ></v-text-field>
        </v-col>
        <v-row class="margin-left">
          <v-col cols="6" class="text-left">
            <v-btn dark color="blue" @click="cargarRespuesta = false">
              <v-icon>plus-thick</v-icon>
              volver</v-btn
            >
          </v-col>
          <v-col cols="6" class="text-right">
            <v-btn dark color="blue" @click="saveRespuesta">
              <v-icon>plus-thick</v-icon>
              Guardar</v-btn
            >
          </v-col>
        </v-row>
      </v-row>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import api from "../../conf/ruta-base";
import store from "../../store";
import router from "../../router";
import XLSX from "xlsx";
import UserProfile from "../../data";
import vueSignature from "vue-signature"

export default {
  name: "Reportes",
  components:{
    vueSignature
  },
  data() {
    return {
      option:{
				penColor:"rgb(0, 0, 0)",
				backgroundColor:"rgb(255,255,255)"
			},
      crearPregunta: false,
      nombreFormulario: "",
      cargarPreguntas: false,
      cargarRespuesta: false,
      obtenerIndexPregunta: 0,
      formPreguntas: {
        text: "",
        index: 0,
        tipo: "",
        respuestas: [],
      },
      formRespuesta: {
        text: "",
      },
      tipoPregunta: [
        { text: "Respuesta múltiple", value: "0" },
        { text: "Verdadero o Falso", value: "1" },
        { text: "Respuesta única", value: "2" },
        { text: "Respuesta libre", value: "3" },
        { text: "Subir archivo", value: "4" },
        { text: "Firma", value: "5" },
      ],
      preguntas: [],
      respuestas: [],

      //Dayana
      apiPath: "tracer",
      search: "",
      dialog: false,
      headers: [
        { text: "Fecha", sortable: true, value: "fecha" },
        { text: "Hora", sortable: true, value: "hora" },
        { text: "Instalación", sortable: true, value: "organizacion.nombre" },
        { text: "Area", sortable: true, value: "area.nombre" },
        {
          text: "Usuario",
          align: "start",
          sortable: true,
          value: "user.nombre",
        },
        { text: "Ubicacion", value: "gps" },
      ],

      calendario: false,
      fecinicio: "",
      fecfin: "",
      dialogofType: null,
      datos: [],
      datawork: [],
      dataworkAnt: [],
      datosImport: [],
      datosExcel: [],
      selec: "",
      date: new Date().toISOString().substr(0, 10),
      editedIndex: -1,
      editedItem: {},
      defaultItem: {
        id: "",
        nombre: "",
        descripcion: "",
        peso: "",
        casoexito: "",
        resultados: "",
      },
    };
  },
  created() {
    this.editedItem = Object.assign({}, this.defaultItem);
  },
  mounted() {
    this.fecinicio = this.date;
    this.fecfin = this.date;
  },
  methods: {
    goVolver() {
      router.push("formulario-dinamico");
    },
    savePregunta() {
      if (
        this.formPreguntas.text.length > 0 &&
        this.formPreguntas.tipo.length > 0
      ) {
        this.formPreguntas.index++;
        this.preguntas.push(this.formPreguntas);
        this.limpiar();
        this.toast("rojo", "pregunta Guardada");
        this.cargarPreguntas = false;
      } else {
        this.toast("rojo", "Campos vacios");
      }
    },
    saveRespuesta() {
      if (this.formRespuesta.text.length > 0) {
        this.preguntas[0].respuestas.push(this.formRespuesta);
        this.respuestas.push(this.formRespuesta);
        this.limpiar();
        this.toast("rojo", "respuesta Guardada");
        this.cargarRespuesta = false;
      } else {
        this.toast("rojo", "Campos vacios");
      }
    },
    indexPregunta() {
      // this.obtenerIndexPregunta = data;
      this.cargarRespuesta = true;
    },
    limpiar() {
      this.formPreguntas = {
        text: "",
        tipo: "",
      };
      this.formRespuesta = {
        text: "",
      };
    },
    //dayaana
    toast(color, text) {
      var toast = { color, text };
      store.commit("TOAST", toast);
    },

    exportExcel(datosXLS) {
      let data = XLSX.utils.json_to_sheet(datosXLS);
      const workbook = XLSX.utils.book_new();
      const filename = "reporte-fullclean";
      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },

    fechasave(evento) {
      if (evento == "inicio") {
        this.fecinicio = this.date;
      } else if (evento == "fin") {
        this.fecfin = this.date;
      }
      this.dialogofType = "";
      this.calendario = false;
      this.date = new Date().toISOString().substr(0, 10);
    },

    fechas(evento) {
      this.dialogofType = evento;
      this.calendario = true;
    },

    consultar() {
      this.datos = [];
      this.datosExcel = [];
      axios
        .get(api.api + this.apiPath + `/rango/${this.fecinicio}/${this.fecfin}`)
        .then((r) => {
          r.data.forEach((reg) => {
            let hora = reg.fecha
              .split("T")[1]
              .split(".")[0]
              .split(":");
            reg.hora = hora[0] + ":" + hora[1];
            reg.fecha = reg.fecha.split("T")[0];
            let excel = {
              Fecha: reg.fecha,
              Hora: reg.hora,
              Instalacion: reg.organizacion.nombre,
              Area: reg.area.nombre,
              Usuario: reg.user.nombre,
              Latitud: reg.lat,
              Longitud: reg.lng,
            };
            this.datosExcel.push(excel);
            this.datos.push(reg);
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //firma

    save(){
			// var _this = this;
      console.log(" this.$refs.signature.save.",  this.$refs.signature);
			 var png = this.$refs.signature[0].save()
			 var jpeg = this.$refs.signature[0].save('image/jpeg')
			 var svg = this.$refs.signature[0].save('image/svg+xml');
			console.log(png);
			console.log(jpeg)
			console.log(svg)
		},
    previewFiles(event) {
      console.log(event.target.files);
   }
	
    
  },
};
</script>

<style scoped>
.margin {
  margin: 12px;
}
.margin-left {
  margin-left: 12px;
}
</style>
<style>
.text-pregunta {
  font-size: 1rem;
  font-weight: bold;
}
.respuestas .v-messages {
  display: none;
}
.v-dialog {
  background-color: #ffffff !important;
}

#signature {
  border: double 3px transparent;
  border-radius: 5px;
  background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-origin: border-box;
  background-clip: content-box, border-box;
}

.container {
  width: "100%";
  padding: 8px 16px;
}

.buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-top: 8px;
}

.marginFirma{
  -webkit-box-shadow: -2px 2px 18px -1px #00000099;
  box-shadow: -2px 2px 18px -1px #00000054;
}


</style>
